import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Card } from "primereact/card";
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import useAxiosPrivate from "../hooks/useAxiosPrivate";
// ⚠️ Ajusta a tu path real

const Cargos = () => {
  const [matricula, setMatricula] = useState('');
  const [alumno, setAlumno] = useState(null);
  const [cargos, setCargos] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    id_concepto: null,
    periodo: '',
    fecha_vencimiento: '',
    monto: null
  });
const axiosPrivate = useAxiosPrivate();
  // 🔹 cargar conceptos
  useEffect(() => {
    const loadConceptos = async () => {
      try {
        const res = await axiosPrivate.get('CEUM/conceptos');
        setConceptos(res.data);
      } catch (e) {
        console.error(e);
      }
    };

    loadConceptos();
  }, []);

  // 🔹 buscar cargos
  const buscar = async () => {
    if (!matricula) return;
    setLoading(true);

    try {
      const res = await axiosPrivate.get(`CEUM/cargos/${matricula}`);

      setCargos(res.data);
      setAlumno({ nombre: 'Alumno', matricula }); // puedes reemplazar con endpoint real
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 guardar cargo
  const guardar = async () => {
    if (!form.id_concepto || !form.periodo || !form.monto) {
      alert('Completa los campos requeridos');
      return;
    }

    try {
      await axiosPrivate.post('CEUM/cargos', {
        matricula,
        ...form
      });

      setVisible(false);
      limpiarForm();
      buscar();
    } catch (e) {
      console.error(e);
      alert('Error al guardar');
    }
  };

  const limpiarForm = () => {
    setForm({
      id_concepto: null,
      periodo: '',
      fecha_vencimiento: '',
      monto: null
    });
  };

  const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;

  return (
    <Card className="card" title='Registro de cargos'>

      {/* 🔍 Buscador */}
      <div className="flex gap-2 mb-3">
        <InputText
          value={matricula}
          onChange={(e) => setMatricula(e.target.value)}
          placeholder="Matrícula"
        />
        <Button label="Buscar" icon="pi pi-search" onClick={buscar} loading={loading} />
        <Button label="Nuevo Cargo" icon="pi pi-plus" onClick={() => setVisible(true)} />
      </div>

      {/* 👤 Alumno */}
      {alumno && (
        <div className="mb-3">
          <strong>{alumno.nombre}</strong> ({alumno.matricula})
        </div>
      )}

      {/* 📊 Tabla */}
      <DataTable value={cargos} paginator rows={10} className="p-datatable-sm">
        <Column field="concepto" header="Concepto" />
        <Column field="periodo" header="Periodo" />
        <Column field="fecha_vencimiento" header="Vencimiento" />
        <Column header="Monto" body={(row) => money(row.monto)} />
        <Column header="Saldo" body={(row) => money(row.saldo)} />
        <Column field="estatus" header="Estatus" />
      </DataTable>

      {/* 🧾 Modal */}
      <Dialog
        header="Nuevo Cargo"
        visible={visible}
        style={{ width: '30vw' }}
        onHide={() => setVisible(false)}
      >
        <div className="p-fluid">

          <div className="field">
            <label>Concepto</label>
            <Dropdown
              value={form.id_concepto}
              options={conceptos}
              optionLabel="nombre"
              optionValue="id"
              onChange={(e) => setForm({ ...form, id_concepto: e.value })}
              placeholder="Selecciona"
            />
          </div>

          <div className="field">
            <label>Periodo</label>
            <InputText
              value={form.periodo}
              onChange={(e) => setForm({ ...form, periodo: e.target.value })}
              placeholder="2026-01"
            />
          </div>

          <div className="field">
            <label>Fecha vencimiento</label>
            <InputText
              value={form.fecha_vencimiento}
              onChange={(e) => setForm({ ...form, fecha_vencimiento: e.target.value })}
              placeholder="YYYY-MM-DD"
            />
          </div>

          <div className="field">
            <label>Monto</label>
            <InputNumber
              value={form.monto}
              onValueChange={(e) => setForm({ ...form, monto: e.value })}
              mode="currency"
              currency="MXN"
            />
          </div>

        </div>

        <div className="flex justify-content-end mt-3">
          <Button label="Cancelar" className="p-button-text" onClick={() => setVisible(false)} />
          <Button label="Guardar" icon="pi pi-check" onClick={guardar} />
        </div>
      </Dialog>

    </Card>
  );
};

export default Cargos;
